export const LABELS = {
	heading: 'Reviews For This Product',
	subHeading1: 'All reviews are from qualified ',
	clickableText: 'Social Nature ',
	subHeading2: ' shoppers.',
	starRating: 'Average Rating',
	verifiedLabel: 'Verified',
	viewAllProducts: 'View all reviews for this product'
};
export const LINKS = {
	socialNature: 'https://www.socialnature.com'
};
